import { Controller, useFormContext } from 'react-hook-form'

import { countries } from 'commons/types/dictionaries'
import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { updateStateField } from '../../../../../../../../helpers'
import { useSubjectInformationItemContext } from '../../../SubjectInformationItemContext'

export const IdCountry = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control, getValues, setValue, clearErrors } = useFormContext<SarEdit>()
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.idsInfo.${index2 as 0}.idCountry`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="Country"
          input={(props) => (
            <Select
              {...props}
              searchable
              data={countries}
              emptyOption={{ label: 'Not selected', value: '' }}
              disabled={isAllInfoUnavailable}
              onChange={(value) => {
                updateStateField(
                  `subjectsInfo.${index1 as 0}.idsInfo.${index2 as 0}.idState`,
                  value,
                  setValue,
                  getValues,
                  clearErrors
                )
                field.onChange(value)
              }}
            />
          )}
        />
      )}
    />
  )
}
